import { Link } from "react-router-dom";

export function MwFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="mw-footer" data-testid="mw-footer">
      <div className="mw-footer-inner">
        <div className="mw-footer-col">
          <div className="mw-footer-brand">MediaWebRadio</div>
          <p className="mw-footer-text">
            Création de radios internet professionnelles. Diffusion fiable,
            installation manuelle, accompagnement sur mesure.
          </p>
        </div>

        <div className="mw-footer-col">
          <div className="mw-footer-title">Nos offres</div>
          <Link to="/offre-stream" className="mw-footer-link">
            Diffuser ma radio sur WallTunes
          </Link>
          <Link to="/offre-pwa" className="mw-footer-link">
            Créer ma PWA radio
          </Link>
          <Link to="/wall" className="mw-footer-link">
            Découvrir le mur WallTunes
          </Link>
        </div>

        <div className="mw-footer-col">
          <div className="mw-footer-title">Contact</div>
          <a
            href="mailto:contact@mediawebradio.net"
            className="mw-footer-link"
            data-testid="mw-footer-email"
          >
            contact@mediawebradio.net
          </a>
          <div className="mw-footer-muted">
            1 Poulton Close — 1st Floor<br />
            Dover (Kent) CT17 0HL — England
          </div>
        </div>
      </div>
      <div className="mw-footer-base">
        <span>© {year} MediaWebRadio — Tous droits réservés</span>
      </div>
    </footer>
  );
}
